<template>
  <hm-content title="">
    <div class="table-panel flex flex-between">
      <el-button type="primary" size="small" @click="addEmployee"
        >添加职员</el-button
      >
      <div>
        <el-input
          clearable
          style="width:200px"
          v-model.trim="keyWords"
          placeholder="请输入账户/用户/手机号/工号"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-cascader
          clearable
          style="marginRight:10px"
          ref="cascader"
          v-model="orgCode"
          :props="props"
          :show-all-levels="false"
          size="small"
          placeholder="请选择机构"
        ></el-cascader>
        <el-select
          clearable
          style="marginRight:10px"
          size="small"
          v-model="workingState"
          placeholder="请选择在职状态"
        >
          <el-option label="在职" value="yes"> </el-option>
          <el-option label="离职" value="no"> </el-option>
        </el-select>
        <el-select
          clearable
          style="marginRight:10px"
          size="small"
          v-model="syncFlag"
          placeholder="请选择是否同步"
        >
          <el-option label="同步" value="erp"> </el-option>
          <el-option label="非同步" value="hemiao"> </el-option>
        </el-select>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button
          type="success"
          size="small"
          @click="output('queryAllList', '职员列表')"
          :loading="isOutputing"
          >导出</el-button
        >
      </div>
    </div>
    <el-table
      :data="allEmployeeList.records"
      stripe
      border
      lazy
      ref="table"
      style="width: 100%"
      size="small"
    >
      <el-table-column
        type="index"
        label="序号"
        :index="index => index + (currentPage - 1) * pageSize + 1"
      ></el-table-column>
      <el-table-column
        prop="username"
        label="用户账号"
        header-align="center"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="realname"
        label="用户名称"
        header-align="center"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="phone"
        label="手机号"
        header-align="center"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="workNum"
        label="工号"
        header-align="center"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="departName"
        label="所属机构"
        header-align="center"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="isManager"
        label="是否主管"
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.isManager === "yes" ? "是" : "否" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="workingState"
        label="状态"
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.workingState === 'yes'">在职</span>
          <span v-if="scope.row.workingState === 'no'">离职</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="syncFlag"
        label="同步状态"
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.syncFlag === "erp" ? "同步" : "非同步" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="memberMobile"
        label="绑定会员信息"
        header-align="center"
        align="center"
        width="200"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.memberMobile">
            <div>手机号：{{ scope.row.memberMobile }}</div>
            <div>会员名：{{ scope.row.memberName }}</div>
          </div>
          <div v-else>
            未绑定
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" header-align="center" align="center">
        <template slot-scope="scope">
          <div class="flex flex-center">
            <el-tooltip class="item" content="编辑" placement="top">
              <button class="pointer mr10 no-bg" @click="edit(scope.row)">
                <span class="hmicon icon-bianji blue"></span>
              </button>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="allEmployeeList.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        :page-sizes="[10, 50, 100, 200]"
        layout="total,  prev, pager, next, jumper, sizes"
        :current-page="currentPage"
        :page-size="pageSize"
      ></el-pagination>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="dialogVisible"
      @close="resetForm('ruleForm')"
    >
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="150px"
      >
        <el-form-item label="用户账号" prop="username">
          <el-input
            clearable
            :disabled="title === '编辑用户'"
            v-model.trim="ruleForm.username"
            maxlength="20"
            size="small"
            placeholder="请输入用户账号（20文本内）"
          ></el-input>
        </el-form-item>
        <el-form-item label="用户密码" prop="password">
          <el-input
            clearable
            autocomplete="new-password"
            v-model.trim="ruleForm.password"
            maxlength="20"
            type="password"
            size="small"
            placeholder="请输入用户密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmpassword">
          <el-input
            clearable
            type="password"
            autocomplete="new-password"
            v-model.trim="ruleForm.confirmpassword"
            maxlength="20"
            size="small"
            placeholder="请确认输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="用户名字" prop="realname">
          <el-input
            clearable
            v-model.trim="ruleForm.realname"
            maxlength="20"
            size="small"
            placeholder="请输入用户名字"
          ></el-input>
        </el-form-item>

        <el-form-item label="门店" prop="shop">
          <el-select
              v-model="ruleForm.shop"
              value-key="id"
              size="small"
              v-if="storeOPenChangeShop"
              filterable
              clearable
              @change="changeShop"
              placeholder="请选择门店"
          >
            <el-option
                v-for="(item, i) in shopList"
                :key="i"
                :label="item.shopName"
                :value="item.shopId"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="所属机构" prop="orgCodes">
          <el-cascader
            ref="cascader"
            clearable
            v-model="ruleForm.orgCodes"
            :props="props"
            :disabled="ruleForm.shop != ''"
            :show-all-levels="false"
            size="small"
          ></el-cascader>
        </el-form-item>

        <el-form-item label="角色分配" prop="ruleLists">
          <el-select
            v-model="ruleForm.ruleLists"
            value-key="id"
            multiple
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="(item, i) in roleList"
              :key="i"
              :label="item.roleName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="工号" prop="workNum">
          <el-input
            :disabled="disabled"
            maxlength="8"
            clearable
            @input="filterGt0OrFixed2('workNum')"
            v-model.trim="ruleForm.workNum"
            size="small"
            placeholder="请输入工号"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input
            clearable
            v-model.trim="ruleForm.phone"
            size="small"
            type="number"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="在职状态" prop="workingState">
          <el-select
            v-model="ruleForm.workingState"
            placeholder="请选择在职状态"
          >
            <el-option label="在职" value="yes"> </el-option>
            <el-option label="离职" value="no"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否主管" prop="isManager">
          <el-select v-model="ruleForm.isManager" placeholder="请选择是否主管">
            <el-option label="是" value="yes"> </el-option>
            <el-option label="否" value="no"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="核销订单关联门店" prop="verifyOrderShopIds">
          <el-select
            clearable
            v-model="ruleForm.verifyOrderShopIds"
            placeholder="请选择门店"
            size="small"
            filterable
            @change="getCheckedStore"
            multiple
          >
            <!-- <el-option
              label="全部门店"
              :disabled="selectOther"
              value="all"
            ></el-option> -->
            <el-option
              :label="v.shopName"
              :value="v.shopId"
              :disabled="selectAll"
              v-for="(v, i) in microShopStoreList"
              :key="i"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label=""> 
          <div class="flex item-center">
      
            <div class="flex">
              <el-button  size="small" @click="outputShop"
                >
                <i class="el-icon-download el-icon--right"></i>
                下载模板
              </el-button>
              <el-button  type="primary" size="small" class="open-file pointer"
                >
                <i class="el-icon-upload el-icon--right"></i>
                导入门店
                <input
                  type="file"
                  class="pointer"
                  @change="importfs"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                />
              </el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="财务订单关联门店" prop="storeShopEmployeeFinanceRelModelList">
          <el-select
            clearable
            v-model="ruleForm.storeShopEmployeeFinanceRelModelList"
            placeholder="请选择门店"
            size="small"
            filterable
            multiple
          >
            <el-option
              :label="v.shopName"
              :value="v.shopId"
              v-for="(v, i) in shopList"
              :key="i"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-select v-model="ruleForm.sex" placeholder="请选择性别">
            <el-option label="男" value="1"> </el-option>
            <el-option label="女" value="2"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="入职时间" prop="regDay">
          <el-date-picker
            v-model="ruleForm.regDay"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="请选择时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="生日" prop="birthday">
          <el-date-picker
            value-format="yyyy-MM-dd"
            v-model="ruleForm.birthday"
            type="date"
            placeholder="请选择时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="地址" prop="address">
          <el-input
            clearable
            v-model.trim="ruleForm.address"
            maxlength="99"
            size="small"
            placeholder="请输入地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="context">
          <el-input
            clearable
            v-model.trim="ruleForm.context"
            maxlength="99"
            size="small"
            placeholder="请输入备注文本"
          ></el-input>
        </el-form-item>
      </el-form>

      <div class="btn-wrapper flex flex-center">
        <el-button size="small" type="primary" @click="save">确 定</el-button>
        <el-button size="small" @click="resetForm('ruleForm')">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="errValidGuider">
      <div slot="title">
        导入失败提示
        <span class="danger"
          >机构重复或者机构不存在会导致导入失败</span
        >
      </div>
      <div>
        <div class="flex flex-between">
          <div>
            您有
            <span class="error">{{ errGuiderResult.length }}</span
            >条数据导入失败
          </div>
          <div>
            您有
            <span class="success"> {{ succGuiderResult.length }}</span
            >条数据导入成功！
          </div>
        </div>
        <el-table
          :data="errGuiderResult"
          border
          class="small-table"
          max-height="500px"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="orgCode"
            label="机构编码"
          ></el-table-column>
           <el-table-column
            header-align="center"
            align="center"
            prop="shopName"
            label="商店名称"
          ></el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import { setCookie, getCookie } from "@/utils/utils";
import {getLoginUser} from "@/utils/auth";
import * as XLSX from "xlsx/xlsx";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  components: {},
  data() {
    const validator = function(rule, val, callback) {
      // if (this.ruleForm.password === this.ruleForm.confirmpassword) {
      //   callback();
      // } else {
      //   return callback(new Error("两次输入密码不一致"));
      // }
      if (val === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    }.bind(this);

    const validatorFunc = function(rule, val, callback) {
      if (this.ruleForm.password === this.ruleForm.confirmpassword) {
        callback();
      } else {
        return callback(new Error("两次输入密码不一致"));
      }
    }.bind(this);

    const validatorOrgCodesFunc = function(rule, val, callback) {
      if (this.isArray(val)) {
        if (val.length <= 0) {
          return callback(new Error("请选择所属机构"));
        }
      } else {
        if (val === "") {
          return callback(new Error("请选择所属机构"));
        }
      }

      // if (this.ruleForm.password === this.ruleForm.confirmpassword) {
      //   callback();
      // } else {
      //
      // }
      callback();
    }.bind(this);
    return {
      selectAll: false,
      isOutputing: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      employeeId: "",
      orgCode: "",
      workingState: "yes",
      syncFlag: "",
      id: "",
      roleList: [],
      title: "",
      disabled: false,
      dialogVisible: false,
      keyWords: "",
      pageSize: 10,
      currentPage: 1,
      ruleForm: {
        username: "",
        realname: "",
        password: "",
        confirmpassword: "",
        phone: "",
        context: "",
        workNum: "",
        birthday: "",
        sex: "",
        regDay: "",
        workingState: "",
        isManager: "",
        ruleLists: [],
        orgCodes: [],
        address: "",
        verifyOrderShopIds: [],
        shop: "",
        storeShopEmployeeFinanceRelModelList: [], //财务关联订单门店
      },
      rules: {
        username: [
          {
            max: 20,
            min: 3,
            message: "长度3-20个字符内",
            trigger: "blur"
          },
          {
            required: true,
            trrger: "blur",
            message: "请输入用户账户"
          }
        ],
        password: [
          {
            required: true,
            validator: validator,
            trigger: "blur"
          },
          { min: 8, max: 48, message: "长度在8到32个字符", trigger: "blur" },
          {
            message: "只能输入数字或字母或数字与字母的组合",
            pattern: /^[0-9a-zA-Z]*$/g,
            trigger: "blur"
          },
          {
            required: true,
            trrger: "blur",
            message: "请输入用户密码"
          }
        ],
        confirmpassword: [
          {
            required: true,
            validator: validatorFunc,
            trigger: "blur"
          },
          { min: 8, max: 48, message: "长度在8到32个字符", trigger: "blur" },
          {
            message: "只能输入数字或字母或数字与字母的组合",
            pattern: /^[0-9a-zA-Z]*$/g,
            trigger: "blur"
          },
          {
            required: true,
            trrger: "blur",
            message: "请再次输入用户密码"
          }
        ],
        realname: [
          {
            max: 20,
            message: "长度在20个字符内",
            trigger: "blur"
          },
          {
            required: true,
            trrger: "blur",
            message: "请输入用户名"
          }
        ],
        orgCodes: {
          required: true,
          validator: validatorOrgCodesFunc,
          message: "请选择所属机构"
        },
        ruleLists: {
          required: true,
          message: "请选择角色"
        },
        workNum: {
          required: true,
          trrger: "blur",
          message: "请输入工号"
        },
        phone: [
          {
            required: true,
            trrger: "blur",
            message: "请输入手机号"
          },
          {
            required: true,
            pattern: /^1[0-9]{10}$/,
            message: "请输入正确的手机号",
            trigger: "blur"
          }
        ],
        workingState: {
          required: true,
          message: "请选择在职状态"
        },
        isManager: {
          required: true,
          message: "请选择是否主管"
        }
      },
      props: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryOrganizationTree", {
                pageNo: 1,
                pageSize: 999,
                loginType: "store"
              })
              .then(res => {
                res.result.records.forEach(v => {
                  v.leaf = Boolean(!v.isParent);
                  v.value = v.orgCode;
                  v.label = v.departName;
                });
                resolve(res.result.records);
              });
          } else {
            this.$store
              .dispatch("queryOrganizationListByParent", {
                parentId: data.treeStruct,
                loginType: "store"
              })
              .then(res => {
                if (res.code === "0" && res.result) {
                  res.result.forEach(v => {
                    v.leaf = Boolean(!v.isParent);
                    v.value = v.orgCode;
                    v.label = v.departName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      shopList: [],
      storeOPenChangeShop: false,
       errGuiderResult: [],
      succGuiderResult: [],
      errValidGuider: false,
    };
  },
  computed: mapGetters(["allEmployeeList", "microShopStoreList"]),
  watch: {
    "ruleForm.ruleLists": {
      handler(val) {},
      deep: true
    }
  },
  created() {
    this.getParamsCookie();
    this.$store.dispatch("queryMicroStoreList");
    this.queryStoreOpenChangeShop();
  },
  mounted() {
    this.queryList();
  },
  methods: {
    //检验商城是否开启换店审核配置
    async queryStoreOpenChangeShop() {
      const { storeCode } = getLoginUser();
      const result = this.$store.dispatch("queryStoreOpenChangeShop", {
        storeCode: storeCode,
        examineType: "职员换店申请"
      });
      this.storeOPenChangeShop = result;
    },
    //修改门店
    changeShop(val) {
      console.log("val", val);
      if (val != "") {
        this.queryShopDepartList(val);
      } else {
        this.ruleForm.orgCodes = "";
      }

    },
    //查询门店信息
    async queryShopDepartList(shopId) {
      let params = {
        shopId: shopId
      };
      const { result } = await this.$store.dispatch("queryDepartInfoByShopIdForStore", params);
      console.log("result", result);
      if (this.isArray(result) && result.length > 0) {
        this.ruleForm.orgCodes = result[0].orgCode;
        setTimeout(() => {
          if (this.$refs.cascader) {
            this.$refs.cascader.presentText = result[0].departName;
          }
        }, 0);
      }

      // this.shopList = result;
    },
    async queryAllShopList() {
      const { result } = await this.$store.dispatch("queryStoreAllEnabledStatusShopList");
      this.shopList = result;
    },
    getCheckedStore(storeList) {
      // this.selectOther = storeList.findIndex(o => o !== "all") > -1;
      this.selectAll = storeList.findIndex(o => o === "all") > -1;
    },
    // 导出excel
    output(funcName, title) {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        const func = this[funcName];
        func()
          .then(res => {
            const list = res.result.records;

            list.forEach(v => {
              v.isManager = v.isManager === "yes" ? "是" : "否";
              v.workingState = v.workingState === "yes" ? "在职" : "离职";
              v.syncFlag = v.syncFlag === "erp" ? "同步" : "非同步";
            });
            let tHeader = this.$refs.table.columns
              .map(o => o.label !== "序号" && o.label !== "操作" && o.label)
              .filter(o => o);
            let filterVal = [];
            if (list.length > 0) {
              filterVal = this.$refs.table.$children
                .map(o => o._props.prop)
                .filter(o => o);
            }
            // const tHeader = [
            //   "活动名称",
            //   "团订单号",
            //   "成团人数",
            //   "拼团类型",
            //   "成团状态",
            //   "商品货号",
            //   "商品条码",
            //   "商品名称",
            //   "商品原价",
            //   "个人订单号",
            //   "参与时间",
            //   "团内身份",
            //   "用户昵称",
            //   "用户手机",
            //   "商品数量",
            //   "实付金额",
            //   "收货人",
            //   "收货地址",
            //   "支付状态"
            // ];
            // const filterVal = [
            //   "gameName",
            //   "teamSn",
            //   "openteamNumber",
            //   "gameType",
            //   "teamState",
            //   "goodsSn",
            //   "specBarcode",
            //   "goodsName",
            //   "retailPrice",
            //   "receiptSn",
            //   "createTime",
            //   "teamPosition",
            //   "nickName",
            //   "memberMobile",
            //   "goodsNum",
            //   "payAmount",
            //   "receiverName",
            //   "address",
            //   "payState"
            // ];
            // if (list.length > 0) {
            //   filterVal = this.$refs.table.$children
            //     .map(o => o._props.prop)
            //     .filter(o => o);
            // }
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              title + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    queryRoleList() {
      const params = {
        pageSize: 99999,
        pageNo: 1,
        column: "createTime",
        order: "desc",
        loginType: "store"
      };
      return this.$store.dispatch("queryRoleList", params);
    },
    queryList() {
      this.setParamsCookie();
      this.$store.dispatch("queryEmployeeList", {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        queryKey: this.keyWords,
        orgCode: this.orgCode,
        workingState: this.workingState,
        syncFlag: this.syncFlag,
        loginType: "store"
      });
    },
    queryAllList() {
      return this.$store.dispatch("queryAllEmployeeList", {
        pageNo: 1,
        pageSize: 999999,
        queryKey: this.keyWords,
        orgCode: this.orgCode,
        workingState: this.workingState,
        syncFlag: this.syncFlag,
        loginType: "store"
      });
    },
    setParamsCookie() {
      let searchCondition = {
        keyWords: this.keyWords,
        // orgCode: this.orgCode,
        workingState: this.workingState,
        syncFlag: this.syncFlag
      };
      setCookie({
        key: "employeeListParams",
        type: "session",
        data: Object.assign({}, searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage
        })
      });
    },
    getParamsCookie() {
      const prams = getCookie({ key: "employeeListParams", type: "session" });
      if (prams) {
        this.keyWords = prams.keyWords;
        // this.orgCode = prams.orgCode;
        this.workingState = prams.workingState;
        this.syncFlag = prams.syncFlag;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      if (typeof this.orgCode == "object") {
        this.orgCode = this.orgCode[this.orgCode.length - 1];
      }
      this.queryList();
    },
    edit(row) {
      if (row.syncFlag === "erp") {
        this.disabled = true;
      }
      this.dialogVisible = true;
      this.title = "编辑用户";
      this.id = row.id;
      this.employeeId = row.employeeId;
      const params = {
        id: row.employeeId
      };
      this.$store.dispatch("queryByIdEmployee", params).then(res => {
        const result = res.result || {};
        if (res.code == 0) {
          result.ruleLists = result.ruleList;
          result.orgCodes = result.orgCode;
          for (let key in result) {
            if (this.ruleForm.hasOwnProperty(key)) {
              this.ruleForm[key] = result[key];
              setTimeout(() => {
                if (this.$refs.cascader) {
                  this.$refs.cascader.presentText = result.departName;
                }
              }, 0);
            }
          }
          this.ruleForm.confirmpassword = this.ruleForm.password;
          this.queryAllShopList();
          if (this.storeOPenChangeShop) {
            if (result.storeShopEmployeeRelModel) {
              this.ruleForm.shop = result.storeShopEmployeeRelModel.shopId;
              this.ruleForm.oldShop = result.storeShopEmployeeRelModel.shopId ;
              this.changeShop(this.ruleForm.shop);
            } else {
              this.ruleForm.oldShop = "";
            }
          }
          this.ruleForm.storeShopEmployeeFinanceRelModelList = result.storeShopEmployeeFinanceRelModelList
            ? result.storeShopEmployeeFinanceRelModelList.map(v => v.shopId)
            : [];
          this.queryRoleList().then(res => {
            this.roleList = res.result.records;
          });
          let list = [];

          result.ruleLists.map(v => {
            list.push(v.roleId);
          });
          this.ruleForm.ruleLists = list;
        }
      });
    },
    addEmployee() {
      this.dialogVisible = true;
      this.disabled = false;
      this.title = "添加职员";
      this.queryAllShopList();
      this.queryRoleList().then(res => {
        this.roleList = res.result.records;
      });
    },
    filterGt0OrFixed2(prop) {
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\w_]/g, ""); //过滤0开头
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      // this.ruleForm[prop] = this.ruleForm[prop]
      //   .replace(".", "$#*")
      //   .replace(/\./g, "")
      //   .replace("$#*", "."); //去除其他"."
      // this.ruleForm[prop] = this.ruleForm[prop].replace(
      //   /^(\d+)\.(\d\d).*$/,
      //   "$1.$2"
      // ); //限制只能输入两个小数
      // if (this.ruleForm[prop].indexOf(".") < 0 && this.ruleForm[prop] != "") {
      //   //首位是0的话去掉
      //   this.ruleForm[prop] = parseFloat(this.ruleForm[prop]);
      // }
    },
    blur() {
      const params = {
        username: this.ruleForm.username,
        workNum: this.ruleForm.workNum,
        id: this.id
      };
      this.$store.dispatch("checkEmployee", params);
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      for (let key in this[formName]) {
        if (
          key === "ruleLists" ||
          key === "orgCodes" ||
          key === "verifyOrderShopIds" ||
          key === "storeShopEmployeeFinanceRelModelList"
        ) {
          this[formName][key] = [];
        } else {
          this[formName][key] = "";
        }
      }
      this.dialogVisible = false;
    },
    save() {
      const { storeCode } = getLoginUser();
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let list = [];

          this.ruleForm.ruleLists.map(v => {
            list.push({ id: v });
          });

          let params = {
            username: this.ruleForm.username,
            workNum: this.ruleForm.workNum
          };

          // this.$store.dispatch("checkEmployee", params).then(res => {
          // if (res.code === "0") {
          // let param = this.ruleForm;

          params.ruleList = list;

          if (typeof this.ruleForm.orgCodes == "object") {
            this.ruleForm.orgCode = this.ruleForm.orgCodes[
              this.ruleForm.orgCodes.length - 1
            ];
          } else {
            this.ruleForm.orgCode = this.ruleForm.orgCodes;
          }

          if (this.title === "编辑用户") {
            params.id = this.id;
            params.employeeId = this.employeeId;
          }
          Object.assign(params, this.ruleForm);
          params.loginType = "store";
          params.storeShopEmployeeFinanceRelModelList = this.ruleForm.storeShopEmployeeFinanceRelModelList.map(v => {
            return { shopId: v };
          });
          if (this.storeOPenChangeShop) {
            if (this.ruleForm.shop != "") {
              params.storeShopEmployeeRelModel = {
                shopId: this.ruleForm.shop
              }
            }
            if (this.ruleForm.oldShop != null && this.ruleForm.oldShop != "undefined") {
              if (this.ruleForm.oldShop != this.ruleForm.shop) {
                params.changeShopType = "yes";
              }
            }
          }
          this.$store
            .dispatch(
              this.title === "添加职员" ? "addEmployee" : "editEmployee",
              params
            )
            .then(res => {
              if (res.code === "0") {
                this.$message({
                  message: "操作成功",
                  type: "success"
                });
                this.dialogVisible = false;
                this.queryList();
              }
            });
          // }
          // });
        } else {
          return false;
        }
      });
    },
    // 导出模板
     outputShop() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = ["商店名称","商店编码","机构名称","机构编码"];
        const data = [];
        exportJsonToExcel(tHeader, data, "门店导入模板");
      });
    },
     // 导入，门店
   importfs(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = async function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64",
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary",
          });
        }
        let result = null;
        wb.SheetNames.forEach((sheetName) => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1,
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        let formatResult = {
          // employeeId: that.employeeId || '',
          // storeCode: getLoginUser().storeCode,
          modelList: []
        };
        that.succGuiderResult = [];
        that.errGuiderResult = [];
        result.forEach((v) => {
          formatResult.modelList.push({
            shopName: v[0] + '',
            shopCode: v[1] + '',
            orgName: v[2] + '',
            orgCode: v[3] + ''
          });
        });
        if (formatResult.modelList.length) {
            const { code,result: arrResult } = await that.$store.dispatch("storeShopEmployeeFinanceRelImportShop", formatResult);
          if (code === "0") {
          if(arrResult.failList && arrResult.failList.length) {
            that.errGuiderResult = arrResult.failList;
            that.errValidGuider = true;
          }
          if(arrResult.successList && arrResult.successList.length) {
           
           arrResult.successList.forEach(v => {
              if (!that.ruleForm.storeShopEmployeeFinanceRelModelList.includes(v.shopId)) {
                that.ruleForm.storeShopEmployeeFinanceRelModelList.push(v.shopId);
              }
            });
             that.succGuiderResult = arrResult.successList;
              that.$message.success("导入成功");
          }
          } else {
            that.$message.error('请导入正确的模板');
          }
        }
       
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
  },
};
</script>
<style lang="scss" scoped></style>
